"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: miimosa/notifier/v1/notifier.proto
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MailWithBody = exports.MailWithTemplateName = exports.MailWithTemplateID = exports.MailCampaign = exports.MailSenderEvent_HeadersEntry = exports.MailSenderEvent = exports.SlackUsersByEmail = exports.SlackSenderEvent = exports.LendingNoteMetadata = exports.LendingProjectUpdatesMetadata = exports.DonationProjectUpdatesMetadata = exports.NotificationRecipient = exports.NotificationSender = exports.NotificationForRecipients = exports.NotificationForAdmins = exports.Notification = exports.CreateNotificationResponse = exports.EmptyMetadata = exports.CreateNotificationRequest = exports.ListNotificationsResponse = exports.ListNotificationsRequest = exports.MarkNotificationViewedResponse = exports.MarkNotificationViewedRequest = exports.ModerateNotificationResponse = exports.ModerateNotificationRequest = exports.ListNotificationsForAdminsResponse = exports.ListNotificationsForAdminsRequest = exports.ListSenderNotificationsResponse = exports.ListSenderNotificationsRequest = exports.CountUnreadNotificationsResponse = exports.CountUnreadNotificationsRequest = exports.CountUnreadNotificationsForUserResponse = exports.CountUnreadNotificationsForUserRequest = exports.GetNotificationResponse = exports.GetNotificationRequest = exports.mailCampaignTypeToJSON = exports.mailCampaignTypeFromJSON = exports.MailCampaignType = exports.notificationStatusToJSON = exports.notificationStatusFromJSON = exports.NotificationStatus = exports.notificationKindToJSON = exports.notificationKindFromJSON = exports.NotificationKind = exports.listNotificationStatusToJSON = exports.listNotificationStatusFromJSON = exports.ListNotificationStatus = exports.moderationStatusToJSON = exports.moderationStatusFromJSON = exports.ModerationStatus = void 0;
exports.NotifierServiceClient = exports.MailAttachment = exports.MailEntity = void 0;
/* eslint-disable */
var health_1 = require("../../common/v1/health");
var idempotency_1 = require("../../common/v1/idempotency");
var pagination_1 = require("../../common/v1/pagination");
exports.ModerationStatus = {
    MODERATION_STATUS_UNSPECIFIED: "MODERATION_STATUS_UNSPECIFIED",
    MODERATION_STATUS_APPROVED: "MODERATION_STATUS_APPROVED",
    MODERATION_STATUS_REJECTED: "MODERATION_STATUS_REJECTED",
    UNRECOGNIZED: "UNRECOGNIZED",
};
function moderationStatusFromJSON(object) {
    switch (object) {
        case 0:
        case "MODERATION_STATUS_UNSPECIFIED":
            return exports.ModerationStatus.MODERATION_STATUS_UNSPECIFIED;
        case 2:
        case "MODERATION_STATUS_APPROVED":
            return exports.ModerationStatus.MODERATION_STATUS_APPROVED;
        case 3:
        case "MODERATION_STATUS_REJECTED":
            return exports.ModerationStatus.MODERATION_STATUS_REJECTED;
        case -1:
        case "UNRECOGNIZED":
        default:
            return exports.ModerationStatus.UNRECOGNIZED;
    }
}
exports.moderationStatusFromJSON = moderationStatusFromJSON;
function moderationStatusToJSON(object) {
    switch (object) {
        case exports.ModerationStatus.MODERATION_STATUS_UNSPECIFIED:
            return "MODERATION_STATUS_UNSPECIFIED";
        case exports.ModerationStatus.MODERATION_STATUS_APPROVED:
            return "MODERATION_STATUS_APPROVED";
        case exports.ModerationStatus.MODERATION_STATUS_REJECTED:
            return "MODERATION_STATUS_REJECTED";
        case exports.ModerationStatus.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
exports.moderationStatusToJSON = moderationStatusToJSON;
exports.ListNotificationStatus = {
    LIST_NOTIFICATION_STATUS_UNSPECIFIED: "LIST_NOTIFICATION_STATUS_UNSPECIFIED",
    LIST_NOTIFICATION_STATUS_UNREAD: "LIST_NOTIFICATION_STATUS_UNREAD",
    LIST_NOTIFICATION_STATUS_READ: "LIST_NOTIFICATION_STATUS_READ",
    UNRECOGNIZED: "UNRECOGNIZED",
};
function listNotificationStatusFromJSON(object) {
    switch (object) {
        case 0:
        case "LIST_NOTIFICATION_STATUS_UNSPECIFIED":
            return exports.ListNotificationStatus.LIST_NOTIFICATION_STATUS_UNSPECIFIED;
        case 2:
        case "LIST_NOTIFICATION_STATUS_UNREAD":
            return exports.ListNotificationStatus.LIST_NOTIFICATION_STATUS_UNREAD;
        case 3:
        case "LIST_NOTIFICATION_STATUS_READ":
            return exports.ListNotificationStatus.LIST_NOTIFICATION_STATUS_READ;
        case -1:
        case "UNRECOGNIZED":
        default:
            return exports.ListNotificationStatus.UNRECOGNIZED;
    }
}
exports.listNotificationStatusFromJSON = listNotificationStatusFromJSON;
function listNotificationStatusToJSON(object) {
    switch (object) {
        case exports.ListNotificationStatus.LIST_NOTIFICATION_STATUS_UNSPECIFIED:
            return "LIST_NOTIFICATION_STATUS_UNSPECIFIED";
        case exports.ListNotificationStatus.LIST_NOTIFICATION_STATUS_UNREAD:
            return "LIST_NOTIFICATION_STATUS_UNREAD";
        case exports.ListNotificationStatus.LIST_NOTIFICATION_STATUS_READ:
            return "LIST_NOTIFICATION_STATUS_READ";
        case exports.ListNotificationStatus.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
exports.listNotificationStatusToJSON = listNotificationStatusToJSON;
exports.NotificationKind = {
    NOTIFICATION_KIND_UNSPECIFIED: "NOTIFICATION_KIND_UNSPECIFIED",
    NOTIFICATION_KIND_DONATION_PROJECT_UPDATES: "NOTIFICATION_KIND_DONATION_PROJECT_UPDATES",
    NOTIFICATION_KIND_LENDING_PROJECT_UPDATES: "NOTIFICATION_KIND_LENDING_PROJECT_UPDATES",
    NOTIFICATION_KIND_LENDING_NOTE: "NOTIFICATION_KIND_LENDING_NOTE",
    NOTIFICATION_KIND_ACCOUNT_DOWNGRADED: "NOTIFICATION_KIND_ACCOUNT_DOWNGRADED",
    UNRECOGNIZED: "UNRECOGNIZED",
};
function notificationKindFromJSON(object) {
    switch (object) {
        case 0:
        case "NOTIFICATION_KIND_UNSPECIFIED":
            return exports.NotificationKind.NOTIFICATION_KIND_UNSPECIFIED;
        case 1:
        case "NOTIFICATION_KIND_DONATION_PROJECT_UPDATES":
            return exports.NotificationKind.NOTIFICATION_KIND_DONATION_PROJECT_UPDATES;
        case 2:
        case "NOTIFICATION_KIND_LENDING_PROJECT_UPDATES":
            return exports.NotificationKind.NOTIFICATION_KIND_LENDING_PROJECT_UPDATES;
        case 3:
        case "NOTIFICATION_KIND_LENDING_NOTE":
            return exports.NotificationKind.NOTIFICATION_KIND_LENDING_NOTE;
        case 4:
        case "NOTIFICATION_KIND_ACCOUNT_DOWNGRADED":
            return exports.NotificationKind.NOTIFICATION_KIND_ACCOUNT_DOWNGRADED;
        case -1:
        case "UNRECOGNIZED":
        default:
            return exports.NotificationKind.UNRECOGNIZED;
    }
}
exports.notificationKindFromJSON = notificationKindFromJSON;
function notificationKindToJSON(object) {
    switch (object) {
        case exports.NotificationKind.NOTIFICATION_KIND_UNSPECIFIED:
            return "NOTIFICATION_KIND_UNSPECIFIED";
        case exports.NotificationKind.NOTIFICATION_KIND_DONATION_PROJECT_UPDATES:
            return "NOTIFICATION_KIND_DONATION_PROJECT_UPDATES";
        case exports.NotificationKind.NOTIFICATION_KIND_LENDING_PROJECT_UPDATES:
            return "NOTIFICATION_KIND_LENDING_PROJECT_UPDATES";
        case exports.NotificationKind.NOTIFICATION_KIND_LENDING_NOTE:
            return "NOTIFICATION_KIND_LENDING_NOTE";
        case exports.NotificationKind.NOTIFICATION_KIND_ACCOUNT_DOWNGRADED:
            return "NOTIFICATION_KIND_ACCOUNT_DOWNGRADED";
        case exports.NotificationKind.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
exports.notificationKindToJSON = notificationKindToJSON;
exports.NotificationStatus = {
    NOTIFICATION_STATUS_UNSPECIFIED: "NOTIFICATION_STATUS_UNSPECIFIED",
    NOTIFICATION_STATUS_AVAILABLE: "NOTIFICATION_STATUS_AVAILABLE",
    NOTIFICATION_STATUS_IN_MODERATION: "NOTIFICATION_STATUS_IN_MODERATION",
    NOTIFICATION_STATUS_REJECTED: "NOTIFICATION_STATUS_REJECTED",
    UNRECOGNIZED: "UNRECOGNIZED",
};
function notificationStatusFromJSON(object) {
    switch (object) {
        case 0:
        case "NOTIFICATION_STATUS_UNSPECIFIED":
            return exports.NotificationStatus.NOTIFICATION_STATUS_UNSPECIFIED;
        case 1:
        case "NOTIFICATION_STATUS_AVAILABLE":
            return exports.NotificationStatus.NOTIFICATION_STATUS_AVAILABLE;
        case 2:
        case "NOTIFICATION_STATUS_IN_MODERATION":
            return exports.NotificationStatus.NOTIFICATION_STATUS_IN_MODERATION;
        case 3:
        case "NOTIFICATION_STATUS_REJECTED":
            return exports.NotificationStatus.NOTIFICATION_STATUS_REJECTED;
        case -1:
        case "UNRECOGNIZED":
        default:
            return exports.NotificationStatus.UNRECOGNIZED;
    }
}
exports.notificationStatusFromJSON = notificationStatusFromJSON;
function notificationStatusToJSON(object) {
    switch (object) {
        case exports.NotificationStatus.NOTIFICATION_STATUS_UNSPECIFIED:
            return "NOTIFICATION_STATUS_UNSPECIFIED";
        case exports.NotificationStatus.NOTIFICATION_STATUS_AVAILABLE:
            return "NOTIFICATION_STATUS_AVAILABLE";
        case exports.NotificationStatus.NOTIFICATION_STATUS_IN_MODERATION:
            return "NOTIFICATION_STATUS_IN_MODERATION";
        case exports.NotificationStatus.NOTIFICATION_STATUS_REJECTED:
            return "NOTIFICATION_STATUS_REJECTED";
        case exports.NotificationStatus.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
exports.notificationStatusToJSON = notificationStatusToJSON;
exports.MailCampaignType = {
    MAIL_CAMPAIGN_TYPE_UNSPECIFIED: "MAIL_CAMPAIGN_TYPE_UNSPECIFIED",
    /** MAIL_CAMPAIGN_TYPE_OVERRIDE - will override the name from the template id if any */
    MAIL_CAMPAIGN_TYPE_OVERRIDE: "MAIL_CAMPAIGN_TYPE_OVERRIDE",
    /** MAIL_CAMPAIGN_TYPE_AUGMENT - will augment the name from the template id if any by adding the value */
    MAIL_CAMPAIGN_TYPE_AUGMENT: "MAIL_CAMPAIGN_TYPE_AUGMENT",
    UNRECOGNIZED: "UNRECOGNIZED",
};
function mailCampaignTypeFromJSON(object) {
    switch (object) {
        case 0:
        case "MAIL_CAMPAIGN_TYPE_UNSPECIFIED":
            return exports.MailCampaignType.MAIL_CAMPAIGN_TYPE_UNSPECIFIED;
        case 1:
        case "MAIL_CAMPAIGN_TYPE_OVERRIDE":
            return exports.MailCampaignType.MAIL_CAMPAIGN_TYPE_OVERRIDE;
        case 2:
        case "MAIL_CAMPAIGN_TYPE_AUGMENT":
            return exports.MailCampaignType.MAIL_CAMPAIGN_TYPE_AUGMENT;
        case -1:
        case "UNRECOGNIZED":
        default:
            return exports.MailCampaignType.UNRECOGNIZED;
    }
}
exports.mailCampaignTypeFromJSON = mailCampaignTypeFromJSON;
function mailCampaignTypeToJSON(object) {
    switch (object) {
        case exports.MailCampaignType.MAIL_CAMPAIGN_TYPE_UNSPECIFIED:
            return "MAIL_CAMPAIGN_TYPE_UNSPECIFIED";
        case exports.MailCampaignType.MAIL_CAMPAIGN_TYPE_OVERRIDE:
            return "MAIL_CAMPAIGN_TYPE_OVERRIDE";
        case exports.MailCampaignType.MAIL_CAMPAIGN_TYPE_AUGMENT:
            return "MAIL_CAMPAIGN_TYPE_AUGMENT";
        case exports.MailCampaignType.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
exports.mailCampaignTypeToJSON = mailCampaignTypeToJSON;
function createBaseGetNotificationRequest() {
    return { notification_id: "" };
}
exports.GetNotificationRequest = {
    fromJSON: function (object) {
        return { notification_id: isSet(object.notification_id) ? globalThis.String(object.notification_id) : "" };
    },
    toJSON: function (message) {
        var obj = {};
        if (message.notification_id !== "") {
            obj.notification_id = message.notification_id;
        }
        return obj;
    },
    create: function (base) {
        return exports.GetNotificationRequest.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var _a;
        var message = createBaseGetNotificationRequest();
        message.notification_id = (_a = object.notification_id) !== null && _a !== void 0 ? _a : "";
        return message;
    },
};
function createBaseGetNotificationResponse() {
    return { notification: undefined };
}
exports.GetNotificationResponse = {
    fromJSON: function (object) {
        return {
            notification: isSet(object.notification) ? exports.NotificationForAdmins.fromJSON(object.notification) : undefined,
        };
    },
    toJSON: function (message) {
        var obj = {};
        if (message.notification !== undefined) {
            obj.notification = exports.NotificationForAdmins.toJSON(message.notification);
        }
        return obj;
    },
    create: function (base) {
        return exports.GetNotificationResponse.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var message = createBaseGetNotificationResponse();
        message.notification = (object.notification !== undefined && object.notification !== null)
            ? exports.NotificationForAdmins.fromPartial(object.notification)
            : undefined;
        return message;
    },
};
function createBaseCountUnreadNotificationsForUserRequest() {
    return { user_id: 0 };
}
exports.CountUnreadNotificationsForUserRequest = {
    fromJSON: function (object) {
        return { user_id: isSet(object.user_id) ? globalThis.Number(object.user_id) : 0 };
    },
    toJSON: function (message) {
        var obj = {};
        if (message.user_id !== 0) {
            obj.user_id = Math.round(message.user_id);
        }
        return obj;
    },
    create: function (base) {
        return exports.CountUnreadNotificationsForUserRequest.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var _a;
        var message = createBaseCountUnreadNotificationsForUserRequest();
        message.user_id = (_a = object.user_id) !== null && _a !== void 0 ? _a : 0;
        return message;
    },
};
function createBaseCountUnreadNotificationsForUserResponse() {
    return { count: 0 };
}
exports.CountUnreadNotificationsForUserResponse = {
    fromJSON: function (object) {
        return { count: isSet(object.count) ? globalThis.Number(object.count) : 0 };
    },
    toJSON: function (message) {
        var obj = {};
        if (message.count !== 0) {
            obj.count = Math.round(message.count);
        }
        return obj;
    },
    create: function (base) {
        return exports.CountUnreadNotificationsForUserResponse.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var _a;
        var message = createBaseCountUnreadNotificationsForUserResponse();
        message.count = (_a = object.count) !== null && _a !== void 0 ? _a : 0;
        return message;
    },
};
function createBaseCountUnreadNotificationsRequest() {
    return {};
}
exports.CountUnreadNotificationsRequest = {
    fromJSON: function (_) {
        return {};
    },
    toJSON: function (_) {
        var obj = {};
        return obj;
    },
    create: function (base) {
        return exports.CountUnreadNotificationsRequest.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (_) {
        var message = createBaseCountUnreadNotificationsRequest();
        return message;
    },
};
function createBaseCountUnreadNotificationsResponse() {
    return { count: 0 };
}
exports.CountUnreadNotificationsResponse = {
    fromJSON: function (object) {
        return { count: isSet(object.count) ? globalThis.Number(object.count) : 0 };
    },
    toJSON: function (message) {
        var obj = {};
        if (message.count !== 0) {
            obj.count = Math.round(message.count);
        }
        return obj;
    },
    create: function (base) {
        return exports.CountUnreadNotificationsResponse.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var _a;
        var message = createBaseCountUnreadNotificationsResponse();
        message.count = (_a = object.count) !== null && _a !== void 0 ? _a : 0;
        return message;
    },
};
function createBaseListSenderNotificationsRequest() {
    return { pagination: undefined, sender_user_id: undefined, project_slug: undefined };
}
exports.ListSenderNotificationsRequest = {
    fromJSON: function (object) {
        return {
            pagination: isSet(object.pagination) ? pagination_1.PaginationRequest.fromJSON(object.pagination) : undefined,
            sender_user_id: isSet(object.sender_user_id) ? globalThis.Number(object.sender_user_id) : undefined,
            project_slug: isSet(object.project_slug) ? globalThis.String(object.project_slug) : undefined,
        };
    },
    toJSON: function (message) {
        var obj = {};
        if (message.pagination !== undefined) {
            obj.pagination = pagination_1.PaginationRequest.toJSON(message.pagination);
        }
        if (message.sender_user_id !== undefined) {
            obj.sender_user_id = Math.round(message.sender_user_id);
        }
        if (message.project_slug !== undefined) {
            obj.project_slug = message.project_slug;
        }
        return obj;
    },
    create: function (base) {
        return exports.ListSenderNotificationsRequest.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var _a, _b;
        var message = createBaseListSenderNotificationsRequest();
        message.pagination = (object.pagination !== undefined && object.pagination !== null)
            ? pagination_1.PaginationRequest.fromPartial(object.pagination)
            : undefined;
        message.sender_user_id = (_a = object.sender_user_id) !== null && _a !== void 0 ? _a : undefined;
        message.project_slug = (_b = object.project_slug) !== null && _b !== void 0 ? _b : undefined;
        return message;
    },
};
function createBaseListSenderNotificationsResponse() {
    return { notifications: [], pagination: undefined };
}
exports.ListSenderNotificationsResponse = {
    fromJSON: function (object) {
        return {
            notifications: globalThis.Array.isArray(object === null || object === void 0 ? void 0 : object.notifications)
                ? object.notifications.map(function (e) { return exports.Notification.fromJSON(e); })
                : [],
            pagination: isSet(object.pagination) ? pagination_1.PaginationResponse.fromJSON(object.pagination) : undefined,
        };
    },
    toJSON: function (message) {
        var _a;
        var obj = {};
        if ((_a = message.notifications) === null || _a === void 0 ? void 0 : _a.length) {
            obj.notifications = message.notifications.map(function (e) { return exports.Notification.toJSON(e); });
        }
        if (message.pagination !== undefined) {
            obj.pagination = pagination_1.PaginationResponse.toJSON(message.pagination);
        }
        return obj;
    },
    create: function (base) {
        return exports.ListSenderNotificationsResponse.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var _a;
        var message = createBaseListSenderNotificationsResponse();
        message.notifications = ((_a = object.notifications) === null || _a === void 0 ? void 0 : _a.map(function (e) { return exports.Notification.fromPartial(e); })) || [];
        message.pagination = (object.pagination !== undefined && object.pagination !== null)
            ? pagination_1.PaginationResponse.fromPartial(object.pagination)
            : undefined;
        return message;
    },
};
function createBaseListNotificationsForAdminsRequest() {
    return { pagination: undefined, filter_status: undefined, filter_kind: undefined };
}
exports.ListNotificationsForAdminsRequest = {
    fromJSON: function (object) {
        return {
            pagination: isSet(object.pagination) ? pagination_1.PaginationRequest.fromJSON(object.pagination) : undefined,
            filter_status: isSet(object.filter_status) ? notificationStatusFromJSON(object.filter_status) : undefined,
            filter_kind: isSet(object.filter_kind) ? notificationKindFromJSON(object.filter_kind) : undefined,
        };
    },
    toJSON: function (message) {
        var obj = {};
        if (message.pagination !== undefined) {
            obj.pagination = pagination_1.PaginationRequest.toJSON(message.pagination);
        }
        if (message.filter_status !== undefined) {
            obj.filter_status = notificationStatusToJSON(message.filter_status);
        }
        if (message.filter_kind !== undefined) {
            obj.filter_kind = notificationKindToJSON(message.filter_kind);
        }
        return obj;
    },
    create: function (base) {
        return exports.ListNotificationsForAdminsRequest.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var _a, _b;
        var message = createBaseListNotificationsForAdminsRequest();
        message.pagination = (object.pagination !== undefined && object.pagination !== null)
            ? pagination_1.PaginationRequest.fromPartial(object.pagination)
            : undefined;
        message.filter_status = (_a = object.filter_status) !== null && _a !== void 0 ? _a : undefined;
        message.filter_kind = (_b = object.filter_kind) !== null && _b !== void 0 ? _b : undefined;
        return message;
    },
};
function createBaseListNotificationsForAdminsResponse() {
    return { notifications: [], pagination: undefined };
}
exports.ListNotificationsForAdminsResponse = {
    fromJSON: function (object) {
        return {
            notifications: globalThis.Array.isArray(object === null || object === void 0 ? void 0 : object.notifications)
                ? object.notifications.map(function (e) { return exports.NotificationForAdmins.fromJSON(e); })
                : [],
            pagination: isSet(object.pagination) ? pagination_1.PaginationResponse.fromJSON(object.pagination) : undefined,
        };
    },
    toJSON: function (message) {
        var _a;
        var obj = {};
        if ((_a = message.notifications) === null || _a === void 0 ? void 0 : _a.length) {
            obj.notifications = message.notifications.map(function (e) { return exports.NotificationForAdmins.toJSON(e); });
        }
        if (message.pagination !== undefined) {
            obj.pagination = pagination_1.PaginationResponse.toJSON(message.pagination);
        }
        return obj;
    },
    create: function (base) {
        return exports.ListNotificationsForAdminsResponse.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var _a;
        var message = createBaseListNotificationsForAdminsResponse();
        message.notifications = ((_a = object.notifications) === null || _a === void 0 ? void 0 : _a.map(function (e) { return exports.NotificationForAdmins.fromPartial(e); })) || [];
        message.pagination = (object.pagination !== undefined && object.pagination !== null)
            ? pagination_1.PaginationResponse.fromPartial(object.pagination)
            : undefined;
        return message;
    },
};
function createBaseModerateNotificationRequest() {
    return {
        notification_id: "",
        status: exports.ModerationStatus.MODERATION_STATUS_UNSPECIFIED,
        moderation_rejection_cause: undefined,
        moderated_by_user_id: 0,
        new_content: undefined,
        new_subject: undefined,
    };
}
exports.ModerateNotificationRequest = {
    fromJSON: function (object) {
        return {
            notification_id: isSet(object.notification_id) ? globalThis.String(object.notification_id) : "",
            status: isSet(object.status)
                ? moderationStatusFromJSON(object.status)
                : exports.ModerationStatus.MODERATION_STATUS_UNSPECIFIED,
            moderation_rejection_cause: isSet(object.moderation_rejection_cause)
                ? globalThis.String(object.moderation_rejection_cause)
                : undefined,
            moderated_by_user_id: isSet(object.moderated_by_user_id) ? globalThis.Number(object.moderated_by_user_id) : 0,
            new_content: isSet(object.new_content) ? globalThis.String(object.new_content) : undefined,
            new_subject: isSet(object.new_subject) ? globalThis.String(object.new_subject) : undefined,
        };
    },
    toJSON: function (message) {
        var obj = {};
        if (message.notification_id !== "") {
            obj.notification_id = message.notification_id;
        }
        if (message.status !== exports.ModerationStatus.MODERATION_STATUS_UNSPECIFIED) {
            obj.status = moderationStatusToJSON(message.status);
        }
        if (message.moderation_rejection_cause !== undefined) {
            obj.moderation_rejection_cause = message.moderation_rejection_cause;
        }
        if (message.moderated_by_user_id !== 0) {
            obj.moderated_by_user_id = Math.round(message.moderated_by_user_id);
        }
        if (message.new_content !== undefined) {
            obj.new_content = message.new_content;
        }
        if (message.new_subject !== undefined) {
            obj.new_subject = message.new_subject;
        }
        return obj;
    },
    create: function (base) {
        return exports.ModerateNotificationRequest.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var _a, _b, _c, _d, _e, _f;
        var message = createBaseModerateNotificationRequest();
        message.notification_id = (_a = object.notification_id) !== null && _a !== void 0 ? _a : "";
        message.status = (_b = object.status) !== null && _b !== void 0 ? _b : exports.ModerationStatus.MODERATION_STATUS_UNSPECIFIED;
        message.moderation_rejection_cause = (_c = object.moderation_rejection_cause) !== null && _c !== void 0 ? _c : undefined;
        message.moderated_by_user_id = (_d = object.moderated_by_user_id) !== null && _d !== void 0 ? _d : 0;
        message.new_content = (_e = object.new_content) !== null && _e !== void 0 ? _e : undefined;
        message.new_subject = (_f = object.new_subject) !== null && _f !== void 0 ? _f : undefined;
        return message;
    },
};
function createBaseModerateNotificationResponse() {
    return { notification: undefined };
}
exports.ModerateNotificationResponse = {
    fromJSON: function (object) {
        return {
            notification: isSet(object.notification) ? exports.NotificationForAdmins.fromJSON(object.notification) : undefined,
        };
    },
    toJSON: function (message) {
        var obj = {};
        if (message.notification !== undefined) {
            obj.notification = exports.NotificationForAdmins.toJSON(message.notification);
        }
        return obj;
    },
    create: function (base) {
        return exports.ModerateNotificationResponse.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var message = createBaseModerateNotificationResponse();
        message.notification = (object.notification !== undefined && object.notification !== null)
            ? exports.NotificationForAdmins.fromPartial(object.notification)
            : undefined;
        return message;
    },
};
function createBaseMarkNotificationViewedRequest() {
    return { notification_id: "" };
}
exports.MarkNotificationViewedRequest = {
    fromJSON: function (object) {
        return { notification_id: isSet(object.notification_id) ? globalThis.String(object.notification_id) : "" };
    },
    toJSON: function (message) {
        var obj = {};
        if (message.notification_id !== "") {
            obj.notification_id = message.notification_id;
        }
        return obj;
    },
    create: function (base) {
        return exports.MarkNotificationViewedRequest.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var _a;
        var message = createBaseMarkNotificationViewedRequest();
        message.notification_id = (_a = object.notification_id) !== null && _a !== void 0 ? _a : "";
        return message;
    },
};
function createBaseMarkNotificationViewedResponse() {
    return { notification: undefined };
}
exports.MarkNotificationViewedResponse = {
    fromJSON: function (object) {
        return {
            notification: isSet(object.notification) ? exports.NotificationForRecipients.fromJSON(object.notification) : undefined,
        };
    },
    toJSON: function (message) {
        var obj = {};
        if (message.notification !== undefined) {
            obj.notification = exports.NotificationForRecipients.toJSON(message.notification);
        }
        return obj;
    },
    create: function (base) {
        return exports.MarkNotificationViewedResponse.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var message = createBaseMarkNotificationViewedResponse();
        message.notification = (object.notification !== undefined && object.notification !== null)
            ? exports.NotificationForRecipients.fromPartial(object.notification)
            : undefined;
        return message;
    },
};
function createBaseListNotificationsRequest() {
    return { pagination: undefined, filter_status: undefined };
}
exports.ListNotificationsRequest = {
    fromJSON: function (object) {
        return {
            pagination: isSet(object.pagination) ? pagination_1.PaginationRequest.fromJSON(object.pagination) : undefined,
            filter_status: isSet(object.filter_status) ? listNotificationStatusFromJSON(object.filter_status) : undefined,
        };
    },
    toJSON: function (message) {
        var obj = {};
        if (message.pagination !== undefined) {
            obj.pagination = pagination_1.PaginationRequest.toJSON(message.pagination);
        }
        if (message.filter_status !== undefined) {
            obj.filter_status = listNotificationStatusToJSON(message.filter_status);
        }
        return obj;
    },
    create: function (base) {
        return exports.ListNotificationsRequest.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var _a;
        var message = createBaseListNotificationsRequest();
        message.pagination = (object.pagination !== undefined && object.pagination !== null)
            ? pagination_1.PaginationRequest.fromPartial(object.pagination)
            : undefined;
        message.filter_status = (_a = object.filter_status) !== null && _a !== void 0 ? _a : undefined;
        return message;
    },
};
function createBaseListNotificationsResponse() {
    return { notifications: [], pagination: undefined };
}
exports.ListNotificationsResponse = {
    fromJSON: function (object) {
        return {
            notifications: globalThis.Array.isArray(object === null || object === void 0 ? void 0 : object.notifications)
                ? object.notifications.map(function (e) { return exports.NotificationForRecipients.fromJSON(e); })
                : [],
            pagination: isSet(object.pagination) ? pagination_1.PaginationResponse.fromJSON(object.pagination) : undefined,
        };
    },
    toJSON: function (message) {
        var _a;
        var obj = {};
        if ((_a = message.notifications) === null || _a === void 0 ? void 0 : _a.length) {
            obj.notifications = message.notifications.map(function (e) { return exports.NotificationForRecipients.toJSON(e); });
        }
        if (message.pagination !== undefined) {
            obj.pagination = pagination_1.PaginationResponse.toJSON(message.pagination);
        }
        return obj;
    },
    create: function (base) {
        return exports.ListNotificationsResponse.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var _a;
        var message = createBaseListNotificationsResponse();
        message.notifications = ((_a = object.notifications) === null || _a === void 0 ? void 0 : _a.map(function (e) { return exports.NotificationForRecipients.fromPartial(e); })) || [];
        message.pagination = (object.pagination !== undefined && object.pagination !== null)
            ? pagination_1.PaginationResponse.fromPartial(object.pagination)
            : undefined;
        return message;
    },
};
function createBaseCreateNotificationRequest() {
    return {
        sender: undefined,
        kind: exports.NotificationKind.NOTIFICATION_KIND_UNSPECIFIED,
        recipients: [],
        subject: "",
        content: "",
        donation_project_updates: undefined,
        lending_project_updates: undefined,
        lending_note: undefined,
        empty: undefined,
    };
}
exports.CreateNotificationRequest = {
    fromJSON: function (object) {
        return {
            sender: isSet(object.sender) ? exports.NotificationSender.fromJSON(object.sender) : undefined,
            kind: isSet(object.kind) ? notificationKindFromJSON(object.kind) : exports.NotificationKind.NOTIFICATION_KIND_UNSPECIFIED,
            recipients: globalThis.Array.isArray(object === null || object === void 0 ? void 0 : object.recipients)
                ? object.recipients.map(function (e) { return exports.NotificationRecipient.fromJSON(e); })
                : [],
            subject: isSet(object.subject) ? globalThis.String(object.subject) : "",
            content: isSet(object.content) ? globalThis.String(object.content) : "",
            donation_project_updates: isSet(object.donation_project_updates)
                ? exports.DonationProjectUpdatesMetadata.fromJSON(object.donation_project_updates)
                : undefined,
            lending_project_updates: isSet(object.lending_project_updates)
                ? exports.LendingProjectUpdatesMetadata.fromJSON(object.lending_project_updates)
                : undefined,
            lending_note: isSet(object.lending_note) ? exports.LendingNoteMetadata.fromJSON(object.lending_note) : undefined,
            empty: isSet(object.empty) ? exports.EmptyMetadata.fromJSON(object.empty) : undefined,
        };
    },
    toJSON: function (message) {
        var _a;
        var obj = {};
        if (message.sender !== undefined) {
            obj.sender = exports.NotificationSender.toJSON(message.sender);
        }
        if (message.kind !== exports.NotificationKind.NOTIFICATION_KIND_UNSPECIFIED) {
            obj.kind = notificationKindToJSON(message.kind);
        }
        if ((_a = message.recipients) === null || _a === void 0 ? void 0 : _a.length) {
            obj.recipients = message.recipients.map(function (e) { return exports.NotificationRecipient.toJSON(e); });
        }
        if (message.subject !== "") {
            obj.subject = message.subject;
        }
        if (message.content !== "") {
            obj.content = message.content;
        }
        if (message.donation_project_updates !== undefined) {
            obj.donation_project_updates = exports.DonationProjectUpdatesMetadata.toJSON(message.donation_project_updates);
        }
        if (message.lending_project_updates !== undefined) {
            obj.lending_project_updates = exports.LendingProjectUpdatesMetadata.toJSON(message.lending_project_updates);
        }
        if (message.lending_note !== undefined) {
            obj.lending_note = exports.LendingNoteMetadata.toJSON(message.lending_note);
        }
        if (message.empty !== undefined) {
            obj.empty = exports.EmptyMetadata.toJSON(message.empty);
        }
        return obj;
    },
    create: function (base) {
        return exports.CreateNotificationRequest.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var _a, _b, _c, _d;
        var message = createBaseCreateNotificationRequest();
        message.sender = (object.sender !== undefined && object.sender !== null)
            ? exports.NotificationSender.fromPartial(object.sender)
            : undefined;
        message.kind = (_a = object.kind) !== null && _a !== void 0 ? _a : exports.NotificationKind.NOTIFICATION_KIND_UNSPECIFIED;
        message.recipients = ((_b = object.recipients) === null || _b === void 0 ? void 0 : _b.map(function (e) { return exports.NotificationRecipient.fromPartial(e); })) || [];
        message.subject = (_c = object.subject) !== null && _c !== void 0 ? _c : "";
        message.content = (_d = object.content) !== null && _d !== void 0 ? _d : "";
        message.donation_project_updates =
            (object.donation_project_updates !== undefined && object.donation_project_updates !== null)
                ? exports.DonationProjectUpdatesMetadata.fromPartial(object.donation_project_updates)
                : undefined;
        message.lending_project_updates =
            (object.lending_project_updates !== undefined && object.lending_project_updates !== null)
                ? exports.LendingProjectUpdatesMetadata.fromPartial(object.lending_project_updates)
                : undefined;
        message.lending_note = (object.lending_note !== undefined && object.lending_note !== null)
            ? exports.LendingNoteMetadata.fromPartial(object.lending_note)
            : undefined;
        message.empty = (object.empty !== undefined && object.empty !== null)
            ? exports.EmptyMetadata.fromPartial(object.empty)
            : undefined;
        return message;
    },
};
function createBaseEmptyMetadata() {
    return {};
}
exports.EmptyMetadata = {
    fromJSON: function (_) {
        return {};
    },
    toJSON: function (_) {
        var obj = {};
        return obj;
    },
    create: function (base) {
        return exports.EmptyMetadata.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (_) {
        var message = createBaseEmptyMetadata();
        return message;
    },
};
function createBaseCreateNotificationResponse() {
    return { notification: undefined };
}
exports.CreateNotificationResponse = {
    fromJSON: function (object) {
        return { notification: isSet(object.notification) ? exports.Notification.fromJSON(object.notification) : undefined };
    },
    toJSON: function (message) {
        var obj = {};
        if (message.notification !== undefined) {
            obj.notification = exports.Notification.toJSON(message.notification);
        }
        return obj;
    },
    create: function (base) {
        return exports.CreateNotificationResponse.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var message = createBaseCreateNotificationResponse();
        message.notification = (object.notification !== undefined && object.notification !== null)
            ? exports.Notification.fromPartial(object.notification)
            : undefined;
        return message;
    },
};
function createBaseNotification() {
    return {
        id: "",
        status: exports.NotificationStatus.NOTIFICATION_STATUS_UNSPECIFIED,
        sender: undefined,
        subject: "",
        content: "",
        kind: exports.NotificationKind.NOTIFICATION_KIND_UNSPECIFIED,
        donation_project_updates: undefined,
        lending_project_updates: undefined,
        lending_note: undefined,
        created_at: "",
        updated_at: "",
        moderated_at: undefined,
        moderation_rejection_cause: undefined,
    };
}
exports.Notification = {
    fromJSON: function (object) {
        return {
            id: isSet(object.id) ? globalThis.String(object.id) : "",
            status: isSet(object.status)
                ? notificationStatusFromJSON(object.status)
                : exports.NotificationStatus.NOTIFICATION_STATUS_UNSPECIFIED,
            sender: isSet(object.sender) ? exports.NotificationSender.fromJSON(object.sender) : undefined,
            subject: isSet(object.subject) ? globalThis.String(object.subject) : "",
            content: isSet(object.content) ? globalThis.String(object.content) : "",
            kind: isSet(object.kind) ? notificationKindFromJSON(object.kind) : exports.NotificationKind.NOTIFICATION_KIND_UNSPECIFIED,
            donation_project_updates: isSet(object.donation_project_updates)
                ? exports.DonationProjectUpdatesMetadata.fromJSON(object.donation_project_updates)
                : undefined,
            lending_project_updates: isSet(object.lending_project_updates)
                ? exports.LendingProjectUpdatesMetadata.fromJSON(object.lending_project_updates)
                : undefined,
            lending_note: isSet(object.lending_note) ? exports.LendingNoteMetadata.fromJSON(object.lending_note) : undefined,
            created_at: isSet(object.created_at) ? globalThis.String(object.created_at) : "",
            updated_at: isSet(object.updated_at) ? globalThis.String(object.updated_at) : "",
            moderated_at: isSet(object.moderated_at) ? globalThis.String(object.moderated_at) : undefined,
            moderation_rejection_cause: isSet(object.moderation_rejection_cause)
                ? globalThis.String(object.moderation_rejection_cause)
                : undefined,
        };
    },
    toJSON: function (message) {
        var obj = {};
        if (message.id !== "") {
            obj.id = message.id;
        }
        if (message.status !== exports.NotificationStatus.NOTIFICATION_STATUS_UNSPECIFIED) {
            obj.status = notificationStatusToJSON(message.status);
        }
        if (message.sender !== undefined) {
            obj.sender = exports.NotificationSender.toJSON(message.sender);
        }
        if (message.subject !== "") {
            obj.subject = message.subject;
        }
        if (message.content !== "") {
            obj.content = message.content;
        }
        if (message.kind !== exports.NotificationKind.NOTIFICATION_KIND_UNSPECIFIED) {
            obj.kind = notificationKindToJSON(message.kind);
        }
        if (message.donation_project_updates !== undefined) {
            obj.donation_project_updates = exports.DonationProjectUpdatesMetadata.toJSON(message.donation_project_updates);
        }
        if (message.lending_project_updates !== undefined) {
            obj.lending_project_updates = exports.LendingProjectUpdatesMetadata.toJSON(message.lending_project_updates);
        }
        if (message.lending_note !== undefined) {
            obj.lending_note = exports.LendingNoteMetadata.toJSON(message.lending_note);
        }
        if (message.created_at !== "") {
            obj.created_at = message.created_at;
        }
        if (message.updated_at !== "") {
            obj.updated_at = message.updated_at;
        }
        if (message.moderated_at !== undefined) {
            obj.moderated_at = message.moderated_at;
        }
        if (message.moderation_rejection_cause !== undefined) {
            obj.moderation_rejection_cause = message.moderation_rejection_cause;
        }
        return obj;
    },
    create: function (base) {
        return exports.Notification.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        var message = createBaseNotification();
        message.id = (_a = object.id) !== null && _a !== void 0 ? _a : "";
        message.status = (_b = object.status) !== null && _b !== void 0 ? _b : exports.NotificationStatus.NOTIFICATION_STATUS_UNSPECIFIED;
        message.sender = (object.sender !== undefined && object.sender !== null)
            ? exports.NotificationSender.fromPartial(object.sender)
            : undefined;
        message.subject = (_c = object.subject) !== null && _c !== void 0 ? _c : "";
        message.content = (_d = object.content) !== null && _d !== void 0 ? _d : "";
        message.kind = (_e = object.kind) !== null && _e !== void 0 ? _e : exports.NotificationKind.NOTIFICATION_KIND_UNSPECIFIED;
        message.donation_project_updates =
            (object.donation_project_updates !== undefined && object.donation_project_updates !== null)
                ? exports.DonationProjectUpdatesMetadata.fromPartial(object.donation_project_updates)
                : undefined;
        message.lending_project_updates =
            (object.lending_project_updates !== undefined && object.lending_project_updates !== null)
                ? exports.LendingProjectUpdatesMetadata.fromPartial(object.lending_project_updates)
                : undefined;
        message.lending_note = (object.lending_note !== undefined && object.lending_note !== null)
            ? exports.LendingNoteMetadata.fromPartial(object.lending_note)
            : undefined;
        message.created_at = (_f = object.created_at) !== null && _f !== void 0 ? _f : "";
        message.updated_at = (_g = object.updated_at) !== null && _g !== void 0 ? _g : "";
        message.moderated_at = (_h = object.moderated_at) !== null && _h !== void 0 ? _h : undefined;
        message.moderation_rejection_cause = (_j = object.moderation_rejection_cause) !== null && _j !== void 0 ? _j : undefined;
        return message;
    },
};
function createBaseNotificationForAdmins() {
    return {
        notification: undefined,
        recipients: [],
        mail_name: "",
        moderation_cause: undefined,
        moderated_by_user_id: undefined,
    };
}
exports.NotificationForAdmins = {
    fromJSON: function (object) {
        return {
            notification: isSet(object.notification) ? exports.Notification.fromJSON(object.notification) : undefined,
            recipients: globalThis.Array.isArray(object === null || object === void 0 ? void 0 : object.recipients)
                ? object.recipients.map(function (e) { return exports.NotificationRecipient.fromJSON(e); })
                : [],
            mail_name: isSet(object.mail_name) ? globalThis.String(object.mail_name) : "",
            moderation_cause: isSet(object.moderation_cause) ? globalThis.String(object.moderation_cause) : undefined,
            moderated_by_user_id: isSet(object.moderated_by_user_id)
                ? globalThis.Number(object.moderated_by_user_id)
                : undefined,
        };
    },
    toJSON: function (message) {
        var _a;
        var obj = {};
        if (message.notification !== undefined) {
            obj.notification = exports.Notification.toJSON(message.notification);
        }
        if ((_a = message.recipients) === null || _a === void 0 ? void 0 : _a.length) {
            obj.recipients = message.recipients.map(function (e) { return exports.NotificationRecipient.toJSON(e); });
        }
        if (message.mail_name !== "") {
            obj.mail_name = message.mail_name;
        }
        if (message.moderation_cause !== undefined) {
            obj.moderation_cause = message.moderation_cause;
        }
        if (message.moderated_by_user_id !== undefined) {
            obj.moderated_by_user_id = Math.round(message.moderated_by_user_id);
        }
        return obj;
    },
    create: function (base) {
        return exports.NotificationForAdmins.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var _a, _b, _c, _d;
        var message = createBaseNotificationForAdmins();
        message.notification = (object.notification !== undefined && object.notification !== null)
            ? exports.Notification.fromPartial(object.notification)
            : undefined;
        message.recipients = ((_a = object.recipients) === null || _a === void 0 ? void 0 : _a.map(function (e) { return exports.NotificationRecipient.fromPartial(e); })) || [];
        message.mail_name = (_b = object.mail_name) !== null && _b !== void 0 ? _b : "";
        message.moderation_cause = (_c = object.moderation_cause) !== null && _c !== void 0 ? _c : undefined;
        message.moderated_by_user_id = (_d = object.moderated_by_user_id) !== null && _d !== void 0 ? _d : undefined;
        return message;
    },
};
function createBaseNotificationForRecipients() {
    return { notification: undefined, viewed_at: undefined };
}
exports.NotificationForRecipients = {
    fromJSON: function (object) {
        return {
            notification: isSet(object.notification) ? exports.Notification.fromJSON(object.notification) : undefined,
            viewed_at: isSet(object.viewed_at) ? globalThis.String(object.viewed_at) : undefined,
        };
    },
    toJSON: function (message) {
        var obj = {};
        if (message.notification !== undefined) {
            obj.notification = exports.Notification.toJSON(message.notification);
        }
        if (message.viewed_at !== undefined) {
            obj.viewed_at = message.viewed_at;
        }
        return obj;
    },
    create: function (base) {
        return exports.NotificationForRecipients.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var _a;
        var message = createBaseNotificationForRecipients();
        message.notification = (object.notification !== undefined && object.notification !== null)
            ? exports.Notification.fromPartial(object.notification)
            : undefined;
        message.viewed_at = (_a = object.viewed_at) !== null && _a !== void 0 ? _a : undefined;
        return message;
    },
};
function createBaseNotificationSender() {
    return { user_id: 0, email: "", first_name: "", last_name: "" };
}
exports.NotificationSender = {
    fromJSON: function (object) {
        return {
            user_id: isSet(object.user_id) ? globalThis.Number(object.user_id) : 0,
            email: isSet(object.email) ? globalThis.String(object.email) : "",
            first_name: isSet(object.first_name) ? globalThis.String(object.first_name) : "",
            last_name: isSet(object.last_name) ? globalThis.String(object.last_name) : "",
        };
    },
    toJSON: function (message) {
        var obj = {};
        if (message.user_id !== 0) {
            obj.user_id = Math.round(message.user_id);
        }
        if (message.email !== "") {
            obj.email = message.email;
        }
        if (message.first_name !== "") {
            obj.first_name = message.first_name;
        }
        if (message.last_name !== "") {
            obj.last_name = message.last_name;
        }
        return obj;
    },
    create: function (base) {
        return exports.NotificationSender.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var _a, _b, _c, _d;
        var message = createBaseNotificationSender();
        message.user_id = (_a = object.user_id) !== null && _a !== void 0 ? _a : 0;
        message.email = (_b = object.email) !== null && _b !== void 0 ? _b : "";
        message.first_name = (_c = object.first_name) !== null && _c !== void 0 ? _c : "";
        message.last_name = (_d = object.last_name) !== null && _d !== void 0 ? _d : "";
        return message;
    },
};
function createBaseNotificationRecipient() {
    return { user_id: 0, email: "", first_name: "", last_name: "" };
}
exports.NotificationRecipient = {
    fromJSON: function (object) {
        return {
            user_id: isSet(object.user_id) ? globalThis.Number(object.user_id) : 0,
            email: isSet(object.email) ? globalThis.String(object.email) : "",
            first_name: isSet(object.first_name) ? globalThis.String(object.first_name) : "",
            last_name: isSet(object.last_name) ? globalThis.String(object.last_name) : "",
        };
    },
    toJSON: function (message) {
        var obj = {};
        if (message.user_id !== 0) {
            obj.user_id = Math.round(message.user_id);
        }
        if (message.email !== "") {
            obj.email = message.email;
        }
        if (message.first_name !== "") {
            obj.first_name = message.first_name;
        }
        if (message.last_name !== "") {
            obj.last_name = message.last_name;
        }
        return obj;
    },
    create: function (base) {
        return exports.NotificationRecipient.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var _a, _b, _c, _d;
        var message = createBaseNotificationRecipient();
        message.user_id = (_a = object.user_id) !== null && _a !== void 0 ? _a : 0;
        message.email = (_b = object.email) !== null && _b !== void 0 ? _b : "";
        message.first_name = (_c = object.first_name) !== null && _c !== void 0 ? _c : "";
        message.last_name = (_d = object.last_name) !== null && _d !== void 0 ? _d : "";
        return message;
    },
};
function createBaseDonationProjectUpdatesMetadata() {
    return { project_slug: "", project_name: "" };
}
exports.DonationProjectUpdatesMetadata = {
    fromJSON: function (object) {
        return {
            project_slug: isSet(object.project_slug) ? globalThis.String(object.project_slug) : "",
            project_name: isSet(object.project_name) ? globalThis.String(object.project_name) : "",
        };
    },
    toJSON: function (message) {
        var obj = {};
        if (message.project_slug !== "") {
            obj.project_slug = message.project_slug;
        }
        if (message.project_name !== "") {
            obj.project_name = message.project_name;
        }
        return obj;
    },
    create: function (base) {
        return exports.DonationProjectUpdatesMetadata.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var _a, _b;
        var message = createBaseDonationProjectUpdatesMetadata();
        message.project_slug = (_a = object.project_slug) !== null && _a !== void 0 ? _a : "";
        message.project_name = (_b = object.project_name) !== null && _b !== void 0 ? _b : "";
        return message;
    },
};
function createBaseLendingProjectUpdatesMetadata() {
    return { project_slug: "", project_name: "" };
}
exports.LendingProjectUpdatesMetadata = {
    fromJSON: function (object) {
        return {
            project_slug: isSet(object.project_slug) ? globalThis.String(object.project_slug) : "",
            project_name: isSet(object.project_name) ? globalThis.String(object.project_name) : "",
        };
    },
    toJSON: function (message) {
        var obj = {};
        if (message.project_slug !== "") {
            obj.project_slug = message.project_slug;
        }
        if (message.project_name !== "") {
            obj.project_name = message.project_name;
        }
        return obj;
    },
    create: function (base) {
        return exports.LendingProjectUpdatesMetadata.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var _a, _b;
        var message = createBaseLendingProjectUpdatesMetadata();
        message.project_slug = (_a = object.project_slug) !== null && _a !== void 0 ? _a : "";
        message.project_name = (_b = object.project_name) !== null && _b !== void 0 ? _b : "";
        return message;
    },
};
function createBaseLendingNoteMetadata() {
    return { project_slug: "", project_name: "" };
}
exports.LendingNoteMetadata = {
    fromJSON: function (object) {
        return {
            project_slug: isSet(object.project_slug) ? globalThis.String(object.project_slug) : "",
            project_name: isSet(object.project_name) ? globalThis.String(object.project_name) : "",
        };
    },
    toJSON: function (message) {
        var obj = {};
        if (message.project_slug !== "") {
            obj.project_slug = message.project_slug;
        }
        if (message.project_name !== "") {
            obj.project_name = message.project_name;
        }
        return obj;
    },
    create: function (base) {
        return exports.LendingNoteMetadata.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var _a, _b;
        var message = createBaseLendingNoteMetadata();
        message.project_slug = (_a = object.project_slug) !== null && _a !== void 0 ? _a : "";
        message.project_name = (_b = object.project_name) !== null && _b !== void 0 ? _b : "";
        return message;
    },
};
function createBaseSlackSenderEvent() {
    return { channel: undefined, users: undefined, simple_text: undefined };
}
exports.SlackSenderEvent = {
    fromJSON: function (object) {
        return {
            channel: isSet(object.channel) ? globalThis.String(object.channel) : undefined,
            users: isSet(object.users) ? exports.SlackUsersByEmail.fromJSON(object.users) : undefined,
            simple_text: isSet(object.simple_text) ? globalThis.String(object.simple_text) : undefined,
        };
    },
    toJSON: function (message) {
        var obj = {};
        if (message.channel !== undefined) {
            obj.channel = message.channel;
        }
        if (message.users !== undefined) {
            obj.users = exports.SlackUsersByEmail.toJSON(message.users);
        }
        if (message.simple_text !== undefined) {
            obj.simple_text = message.simple_text;
        }
        return obj;
    },
    create: function (base) {
        return exports.SlackSenderEvent.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var _a, _b;
        var message = createBaseSlackSenderEvent();
        message.channel = (_a = object.channel) !== null && _a !== void 0 ? _a : undefined;
        message.users = (object.users !== undefined && object.users !== null)
            ? exports.SlackUsersByEmail.fromPartial(object.users)
            : undefined;
        message.simple_text = (_b = object.simple_text) !== null && _b !== void 0 ? _b : undefined;
        return message;
    },
};
function createBaseSlackUsersByEmail() {
    return { emails: [] };
}
exports.SlackUsersByEmail = {
    fromJSON: function (object) {
        return {
            emails: globalThis.Array.isArray(object === null || object === void 0 ? void 0 : object.emails) ? object.emails.map(function (e) { return globalThis.String(e); }) : [],
        };
    },
    toJSON: function (message) {
        var _a;
        var obj = {};
        if ((_a = message.emails) === null || _a === void 0 ? void 0 : _a.length) {
            obj.emails = message.emails;
        }
        return obj;
    },
    create: function (base) {
        return exports.SlackUsersByEmail.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var _a;
        var message = createBaseSlackUsersByEmail();
        message.emails = ((_a = object.emails) === null || _a === void 0 ? void 0 : _a.map(function (e) { return e; })) || [];
        return message;
    },
};
function createBaseMailSenderEvent() {
    return {
        to: [],
        cc: [],
        bcc: [],
        attachments: [],
        headers: {},
        subject: undefined,
        from: undefined,
        custom_id: undefined,
        variables_json: undefined,
        campaign: undefined,
        idempotency: undefined,
        with_template_id: undefined,
        with_body: undefined,
        with_template_name: undefined,
    };
}
exports.MailSenderEvent = {
    fromJSON: function (object) {
        return {
            to: globalThis.Array.isArray(object === null || object === void 0 ? void 0 : object.to) ? object.to.map(function (e) { return exports.MailEntity.fromJSON(e); }) : [],
            cc: globalThis.Array.isArray(object === null || object === void 0 ? void 0 : object.cc) ? object.cc.map(function (e) { return exports.MailEntity.fromJSON(e); }) : [],
            bcc: globalThis.Array.isArray(object === null || object === void 0 ? void 0 : object.bcc) ? object.bcc.map(function (e) { return exports.MailEntity.fromJSON(e); }) : [],
            attachments: globalThis.Array.isArray(object === null || object === void 0 ? void 0 : object.attachments)
                ? object.attachments.map(function (e) { return exports.MailAttachment.fromJSON(e); })
                : [],
            headers: isObject(object.headers)
                ? Object.entries(object.headers).reduce(function (acc, _a) {
                    var key = _a[0], value = _a[1];
                    acc[key] = String(value);
                    return acc;
                }, {})
                : {},
            subject: isSet(object.subject) ? globalThis.String(object.subject) : undefined,
            from: isSet(object.from) ? exports.MailEntity.fromJSON(object.from) : undefined,
            custom_id: isSet(object.custom_id) ? globalThis.String(object.custom_id) : undefined,
            variables_json: isSet(object.variables_json) ? globalThis.String(object.variables_json) : undefined,
            campaign: isSet(object.campaign) ? exports.MailCampaign.fromJSON(object.campaign) : undefined,
            idempotency: isSet(object.idempotency) ? idempotency_1.Idempotency.fromJSON(object.idempotency) : undefined,
            with_template_id: isSet(object.with_template_id)
                ? exports.MailWithTemplateID.fromJSON(object.with_template_id)
                : undefined,
            with_body: isSet(object.with_body) ? exports.MailWithBody.fromJSON(object.with_body) : undefined,
            with_template_name: isSet(object.with_template_name)
                ? exports.MailWithTemplateName.fromJSON(object.with_template_name)
                : undefined,
        };
    },
    toJSON: function (message) {
        var _a, _b, _c, _d;
        var obj = {};
        if ((_a = message.to) === null || _a === void 0 ? void 0 : _a.length) {
            obj.to = message.to.map(function (e) { return exports.MailEntity.toJSON(e); });
        }
        if ((_b = message.cc) === null || _b === void 0 ? void 0 : _b.length) {
            obj.cc = message.cc.map(function (e) { return exports.MailEntity.toJSON(e); });
        }
        if ((_c = message.bcc) === null || _c === void 0 ? void 0 : _c.length) {
            obj.bcc = message.bcc.map(function (e) { return exports.MailEntity.toJSON(e); });
        }
        if ((_d = message.attachments) === null || _d === void 0 ? void 0 : _d.length) {
            obj.attachments = message.attachments.map(function (e) { return exports.MailAttachment.toJSON(e); });
        }
        if (message.headers) {
            var entries = Object.entries(message.headers);
            if (entries.length > 0) {
                obj.headers = {};
                entries.forEach(function (_a) {
                    var k = _a[0], v = _a[1];
                    obj.headers[k] = v;
                });
            }
        }
        if (message.subject !== undefined) {
            obj.subject = message.subject;
        }
        if (message.from !== undefined) {
            obj.from = exports.MailEntity.toJSON(message.from);
        }
        if (message.custom_id !== undefined) {
            obj.custom_id = message.custom_id;
        }
        if (message.variables_json !== undefined) {
            obj.variables_json = message.variables_json;
        }
        if (message.campaign !== undefined) {
            obj.campaign = exports.MailCampaign.toJSON(message.campaign);
        }
        if (message.idempotency !== undefined) {
            obj.idempotency = idempotency_1.Idempotency.toJSON(message.idempotency);
        }
        if (message.with_template_id !== undefined) {
            obj.with_template_id = exports.MailWithTemplateID.toJSON(message.with_template_id);
        }
        if (message.with_body !== undefined) {
            obj.with_body = exports.MailWithBody.toJSON(message.with_body);
        }
        if (message.with_template_name !== undefined) {
            obj.with_template_name = exports.MailWithTemplateName.toJSON(message.with_template_name);
        }
        return obj;
    },
    create: function (base) {
        return exports.MailSenderEvent.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        var message = createBaseMailSenderEvent();
        message.to = ((_a = object.to) === null || _a === void 0 ? void 0 : _a.map(function (e) { return exports.MailEntity.fromPartial(e); })) || [];
        message.cc = ((_b = object.cc) === null || _b === void 0 ? void 0 : _b.map(function (e) { return exports.MailEntity.fromPartial(e); })) || [];
        message.bcc = ((_c = object.bcc) === null || _c === void 0 ? void 0 : _c.map(function (e) { return exports.MailEntity.fromPartial(e); })) || [];
        message.attachments = ((_d = object.attachments) === null || _d === void 0 ? void 0 : _d.map(function (e) { return exports.MailAttachment.fromPartial(e); })) || [];
        message.headers = Object.entries((_e = object.headers) !== null && _e !== void 0 ? _e : {}).reduce(function (acc, _a) {
            var key = _a[0], value = _a[1];
            if (value !== undefined) {
                acc[key] = globalThis.String(value);
            }
            return acc;
        }, {});
        message.subject = (_f = object.subject) !== null && _f !== void 0 ? _f : undefined;
        message.from = (object.from !== undefined && object.from !== null)
            ? exports.MailEntity.fromPartial(object.from)
            : undefined;
        message.custom_id = (_g = object.custom_id) !== null && _g !== void 0 ? _g : undefined;
        message.variables_json = (_h = object.variables_json) !== null && _h !== void 0 ? _h : undefined;
        message.campaign = (object.campaign !== undefined && object.campaign !== null)
            ? exports.MailCampaign.fromPartial(object.campaign)
            : undefined;
        message.idempotency = (object.idempotency !== undefined && object.idempotency !== null)
            ? idempotency_1.Idempotency.fromPartial(object.idempotency)
            : undefined;
        message.with_template_id = (object.with_template_id !== undefined && object.with_template_id !== null)
            ? exports.MailWithTemplateID.fromPartial(object.with_template_id)
            : undefined;
        message.with_body = (object.with_body !== undefined && object.with_body !== null)
            ? exports.MailWithBody.fromPartial(object.with_body)
            : undefined;
        message.with_template_name = (object.with_template_name !== undefined && object.with_template_name !== null)
            ? exports.MailWithTemplateName.fromPartial(object.with_template_name)
            : undefined;
        return message;
    },
};
function createBaseMailSenderEvent_HeadersEntry() {
    return { key: "", value: "" };
}
exports.MailSenderEvent_HeadersEntry = {
    fromJSON: function (object) {
        return {
            key: isSet(object.key) ? globalThis.String(object.key) : "",
            value: isSet(object.value) ? globalThis.String(object.value) : "",
        };
    },
    toJSON: function (message) {
        var obj = {};
        if (message.key !== "") {
            obj.key = message.key;
        }
        if (message.value !== "") {
            obj.value = message.value;
        }
        return obj;
    },
    create: function (base) {
        return exports.MailSenderEvent_HeadersEntry.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var _a, _b;
        var message = createBaseMailSenderEvent_HeadersEntry();
        message.key = (_a = object.key) !== null && _a !== void 0 ? _a : "";
        message.value = (_b = object.value) !== null && _b !== void 0 ? _b : "";
        return message;
    },
};
function createBaseMailCampaign() {
    return { value: "", type: exports.MailCampaignType.MAIL_CAMPAIGN_TYPE_UNSPECIFIED };
}
exports.MailCampaign = {
    fromJSON: function (object) {
        return {
            value: isSet(object.value) ? globalThis.String(object.value) : "",
            type: isSet(object.type)
                ? mailCampaignTypeFromJSON(object.type)
                : exports.MailCampaignType.MAIL_CAMPAIGN_TYPE_UNSPECIFIED,
        };
    },
    toJSON: function (message) {
        var obj = {};
        if (message.value !== "") {
            obj.value = message.value;
        }
        if (message.type !== exports.MailCampaignType.MAIL_CAMPAIGN_TYPE_UNSPECIFIED) {
            obj.type = mailCampaignTypeToJSON(message.type);
        }
        return obj;
    },
    create: function (base) {
        return exports.MailCampaign.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var _a, _b;
        var message = createBaseMailCampaign();
        message.value = (_a = object.value) !== null && _a !== void 0 ? _a : "";
        message.type = (_b = object.type) !== null && _b !== void 0 ? _b : exports.MailCampaignType.MAIL_CAMPAIGN_TYPE_UNSPECIFIED;
        return message;
    },
};
function createBaseMailWithTemplateID() {
    return { template_id: 0 };
}
exports.MailWithTemplateID = {
    fromJSON: function (object) {
        return { template_id: isSet(object.template_id) ? globalThis.Number(object.template_id) : 0 };
    },
    toJSON: function (message) {
        var obj = {};
        if (message.template_id !== 0) {
            obj.template_id = Math.round(message.template_id);
        }
        return obj;
    },
    create: function (base) {
        return exports.MailWithTemplateID.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var _a;
        var message = createBaseMailWithTemplateID();
        message.template_id = (_a = object.template_id) !== null && _a !== void 0 ? _a : 0;
        return message;
    },
};
function createBaseMailWithTemplateName() {
    return { template_name: "" };
}
exports.MailWithTemplateName = {
    fromJSON: function (object) {
        return { template_name: isSet(object.template_name) ? globalThis.String(object.template_name) : "" };
    },
    toJSON: function (message) {
        var obj = {};
        if (message.template_name !== "") {
            obj.template_name = message.template_name;
        }
        return obj;
    },
    create: function (base) {
        return exports.MailWithTemplateName.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var _a;
        var message = createBaseMailWithTemplateName();
        message.template_name = (_a = object.template_name) !== null && _a !== void 0 ? _a : "";
        return message;
    },
};
function createBaseMailWithBody() {
    return { html_part: "", text_part: undefined };
}
exports.MailWithBody = {
    fromJSON: function (object) {
        return {
            html_part: isSet(object.html_part) ? globalThis.String(object.html_part) : "",
            text_part: isSet(object.text_part) ? globalThis.String(object.text_part) : undefined,
        };
    },
    toJSON: function (message) {
        var obj = {};
        if (message.html_part !== "") {
            obj.html_part = message.html_part;
        }
        if (message.text_part !== undefined) {
            obj.text_part = message.text_part;
        }
        return obj;
    },
    create: function (base) {
        return exports.MailWithBody.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var _a, _b;
        var message = createBaseMailWithBody();
        message.html_part = (_a = object.html_part) !== null && _a !== void 0 ? _a : "";
        message.text_part = (_b = object.text_part) !== null && _b !== void 0 ? _b : undefined;
        return message;
    },
};
function createBaseMailEntity() {
    return { email: "", name: "" };
}
exports.MailEntity = {
    fromJSON: function (object) {
        return {
            email: isSet(object.email) ? globalThis.String(object.email) : "",
            name: isSet(object.name) ? globalThis.String(object.name) : "",
        };
    },
    toJSON: function (message) {
        var obj = {};
        if (message.email !== "") {
            obj.email = message.email;
        }
        if (message.name !== "") {
            obj.name = message.name;
        }
        return obj;
    },
    create: function (base) {
        return exports.MailEntity.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var _a, _b;
        var message = createBaseMailEntity();
        message.email = (_a = object.email) !== null && _a !== void 0 ? _a : "";
        message.name = (_b = object.name) !== null && _b !== void 0 ? _b : "";
        return message;
    },
};
function createBaseMailAttachment() {
    return { name: "", content_b64: "", content_type: "" };
}
exports.MailAttachment = {
    fromJSON: function (object) {
        return {
            name: isSet(object.name) ? globalThis.String(object.name) : "",
            content_b64: isSet(object.content_b64) ? globalThis.String(object.content_b64) : "",
            content_type: isSet(object.content_type) ? globalThis.String(object.content_type) : "",
        };
    },
    toJSON: function (message) {
        var obj = {};
        if (message.name !== "") {
            obj.name = message.name;
        }
        if (message.content_b64 !== "") {
            obj.content_b64 = message.content_b64;
        }
        if (message.content_type !== "") {
            obj.content_type = message.content_type;
        }
        return obj;
    },
    create: function (base) {
        return exports.MailAttachment.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var _a, _b, _c;
        var message = createBaseMailAttachment();
        message.name = (_a = object.name) !== null && _a !== void 0 ? _a : "";
        message.content_b64 = (_b = object.content_b64) !== null && _b !== void 0 ? _b : "";
        message.content_type = (_c = object.content_type) !== null && _c !== void 0 ? _c : "";
        return message;
    },
};
function isObject(value) {
    return typeof value === "object" && value !== null;
}
function isSet(value) {
    return value !== null && value !== undefined;
}
function handleRequest(url, requestBody, fromJSON, options) {
    var _a;
    return __awaiter(this, void 0, void 0, function () {
        var response, responseBody, parseError_1, error_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 7, , 8]);
                    if (options === null || options === void 0 ? void 0 : options.debug) {
                        console.log('[CLIENT DEBUG] request:\n', JSON.stringify(requestBody));
                    }
                    return [4 /*yield*/, fetch(url, {
                            method: 'POST',
                            body: JSON.stringify(requestBody),
                            headers: __assign(__assign({ 'Content-Type': 'application/json' }, ((_a = options === null || options === void 0 ? void 0 : options.headers) !== null && _a !== void 0 ? _a : {})), ((options === null || options === void 0 ? void 0 : options.user_id) ? { 'X-Jwt-Payload-B64': options.user_id } : {}))
                        })];
                case 1:
                    response = _b.sent();
                    if (options === null || options === void 0 ? void 0 : options.debug) {
                        console.log('[CLIENT DEBUG] response:\n', JSON.stringify(response));
                    }
                    responseBody = void 0;
                    _b.label = 2;
                case 2:
                    _b.trys.push([2, 4, , 6]);
                    return [4 /*yield*/, response.json()];
                case 3:
                    responseBody = _b.sent();
                    return [3 /*break*/, 6];
                case 4:
                    parseError_1 = _b.sent();
                    return [4 /*yield*/, response.text()];
                case 5:
                    responseBody = _b.sent();
                    return [3 /*break*/, 6];
                case 6:
                    if (!response.ok) {
                        throw {
                            statusText: response.statusText || 'HTTP Error',
                            body: responseBody
                        };
                    }
                    return [2 /*return*/, fromJSON(responseBody)];
                case 7:
                    error_1 = _b.sent();
                    if (options === null || options === void 0 ? void 0 : options.debug) {
                        console.error('[CLIENT DEBUG] error:\n', JSON.stringify(error_1));
                    }
                    if (error_1.statusText) {
                        // This is our custom error object from above
                        throw error_1;
                    }
                    else {
                        // This could be a network error or other fetch-related error
                        throw {
                            statusText: 'Network Error',
                            body: error_1.message || 'An unknown error occurred',
                            error: error_1,
                        };
                    }
                    return [3 /*break*/, 8];
                case 8: return [2 /*return*/];
            }
        });
    });
}
var NotifierServiceClient = /** @class */ (function () {
    function NotifierServiceClient(fetcher, baseURL) {
        this.fetcher = fetcher;
        this.baseURL = baseURL;
    }
    NotifierServiceClient.prototype.Health = function (request, options) {
        return __awaiter(this, void 0, void 0, function () {
            var jsonReq, url;
            return __generator(this, function (_a) {
                jsonReq = health_1.HealthRequest.toJSON(request);
                url = this.baseURL + "/twirp/miimosa.notifier.v1.NotifierService/Health";
                return [2 /*return*/, handleRequest(url, jsonReq, health_1.HealthResponse.fromJSON, options)];
            });
        });
    };
    NotifierServiceClient.prototype.CreateNotification = function (request, options) {
        return __awaiter(this, void 0, void 0, function () {
            var jsonReq, url;
            return __generator(this, function (_a) {
                jsonReq = exports.CreateNotificationRequest.toJSON(request);
                url = this.baseURL + "/twirp/miimosa.notifier.v1.NotifierService/CreateNotification";
                return [2 /*return*/, handleRequest(url, jsonReq, exports.CreateNotificationResponse.fromJSON, options)];
            });
        });
    };
    NotifierServiceClient.prototype.ModerateNotification = function (request, options) {
        return __awaiter(this, void 0, void 0, function () {
            var jsonReq, url;
            return __generator(this, function (_a) {
                jsonReq = exports.ModerateNotificationRequest.toJSON(request);
                url = this.baseURL + "/twirp/miimosa.notifier.v1.NotifierService/ModerateNotification";
                return [2 /*return*/, handleRequest(url, jsonReq, exports.ModerateNotificationResponse.fromJSON, options)];
            });
        });
    };
    NotifierServiceClient.prototype.ListNotificationsForAdmins = function (request, options) {
        return __awaiter(this, void 0, void 0, function () {
            var jsonReq, url;
            return __generator(this, function (_a) {
                jsonReq = exports.ListNotificationsForAdminsRequest.toJSON(request);
                url = this.baseURL + "/twirp/miimosa.notifier.v1.NotifierService/ListNotificationsForAdmins";
                return [2 /*return*/, handleRequest(url, jsonReq, exports.ListNotificationsForAdminsResponse.fromJSON, options)];
            });
        });
    };
    NotifierServiceClient.prototype.GetNotification = function (request, options) {
        return __awaiter(this, void 0, void 0, function () {
            var jsonReq, url;
            return __generator(this, function (_a) {
                jsonReq = exports.GetNotificationRequest.toJSON(request);
                url = this.baseURL + "/twirp/miimosa.notifier.v1.NotifierService/GetNotification";
                return [2 /*return*/, handleRequest(url, jsonReq, exports.GetNotificationResponse.fromJSON, options)];
            });
        });
    };
    NotifierServiceClient.prototype.ListSenderNotifications = function (request, options) {
        return __awaiter(this, void 0, void 0, function () {
            var jsonReq, url;
            return __generator(this, function (_a) {
                jsonReq = exports.ListSenderNotificationsRequest.toJSON(request);
                url = this.baseURL + "/twirp/miimosa.notifier.v1.NotifierService/ListSenderNotifications";
                return [2 /*return*/, handleRequest(url, jsonReq, exports.ListSenderNotificationsResponse.fromJSON, options)];
            });
        });
    };
    NotifierServiceClient.prototype.CountUnreadNotificationsForUser = function (request, options) {
        return __awaiter(this, void 0, void 0, function () {
            var jsonReq, url;
            return __generator(this, function (_a) {
                jsonReq = exports.CountUnreadNotificationsForUserRequest.toJSON(request);
                url = this.baseURL + "/twirp/miimosa.notifier.v1.NotifierService/CountUnreadNotificationsForUser";
                return [2 /*return*/, handleRequest(url, jsonReq, exports.CountUnreadNotificationsForUserResponse.fromJSON, options)];
            });
        });
    };
    NotifierServiceClient.prototype.ListNotifications = function (request, options) {
        return __awaiter(this, void 0, void 0, function () {
            var jsonReq, url;
            return __generator(this, function (_a) {
                jsonReq = exports.ListNotificationsRequest.toJSON(request);
                url = this.baseURL + "/twirp/miimosa.notifier.v1.NotifierService/ListNotifications";
                return [2 /*return*/, handleRequest(url, jsonReq, exports.ListNotificationsResponse.fromJSON, options)];
            });
        });
    };
    NotifierServiceClient.prototype.MarkNotificationViewed = function (request, options) {
        return __awaiter(this, void 0, void 0, function () {
            var jsonReq, url;
            return __generator(this, function (_a) {
                jsonReq = exports.MarkNotificationViewedRequest.toJSON(request);
                url = this.baseURL + "/twirp/miimosa.notifier.v1.NotifierService/MarkNotificationViewed";
                return [2 /*return*/, handleRequest(url, jsonReq, exports.MarkNotificationViewedResponse.fromJSON, options)];
            });
        });
    };
    NotifierServiceClient.prototype.CountUnreadNotifications = function (request, options) {
        return __awaiter(this, void 0, void 0, function () {
            var jsonReq, url;
            return __generator(this, function (_a) {
                jsonReq = exports.CountUnreadNotificationsRequest.toJSON(request);
                url = this.baseURL + "/twirp/miimosa.notifier.v1.NotifierService/CountUnreadNotifications";
                return [2 /*return*/, handleRequest(url, jsonReq, exports.CountUnreadNotificationsResponse.fromJSON, options)];
            });
        });
    };
    return NotifierServiceClient;
}());
exports.NotifierServiceClient = NotifierServiceClient;
//# sourceMappingURL=notifier.js.map